import React, {CSSProperties, memo, ReactNode} from 'react';
import './index.scss';

export const Row = memo(function Row({children, style}: { children: ReactNode; style?: CSSProperties }) {
    return (
        <div className={'appRow'} style={style}>
            {children}
        </div>
    );
});
